var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectSubtype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_818",
    "data-name": "Rectangle 818",
    width: 14,
    height: 13,
    transform: "translate(-0.368 -0.2)",
    fill: "#0000b5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "project-subtype",
    transform: "translate(-405 -678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488",
    transform: "translate(405.368 682.2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M10.967,12.7H1.737a.487.487,0,0,0-.068-.023A1.947,1.947,0,0,1,.063,11.228c-.026-.086-.042-.174-.063-.262V1.737a.45.45,0,0,0,.023-.068A1.914,1.914,0,0,1,1.106.2,4.418,4.418,0,0,1,1.737,0h.323A.455.455,0,0,1,2.34.483c-.009.851,0,1.7,0,2.554V3.18h8.03V3.024c0-.847.005-1.694,0-2.541A.454.454,0,0,1,10.644,0h.323a.485.485,0,0,0,.067.023A1.944,1.944,0,0,1,12.64,1.477c.025.085.042.173.063.26v9.23a.483.483,0,0,0-.023.068,1.945,1.945,0,0,1-1.452,1.606c-.086.026-.174.043-.261.064M2.337,3.942V4.1q0,2.468,0,4.936c0,.343-.106.463-.448.488A1.215,1.215,0,0,0,.9,11.337a1.18,1.18,0,0,0,1.121.621q4.328,0,8.656,0c.033,0,.066,0,.1,0a1.2,1.2,0,0,0,1.158-1.377,1.173,1.173,0,0,0-1.1-1.055c-.368-.03-.47-.139-.47-.505q0-2.456,0-4.911V3.942ZM1.588.81C1.547.823,1.524.829,1.5.838A1.221,1.221,0,0,0,.745,2q0,3.54,0,7.079v.074l.843-.383ZM11.959,9.152V4.64c0-.889.006-1.778,0-2.667A1.191,1.191,0,0,0,11.245.856a1.121,1.121,0,0,0-.127-.045V8.768l.841.384",
    transform: "translate(0 -0.215)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M169.5,218.8q0-.769,0-1.537a.381.381,0,0,1,.421-.423H173a.381.381,0,0,1,.425.42q0,1.55,0,3.1a.379.379,0,0,1-.415.417q-1.55,0-3.1,0a.381.381,0,0,1-.418-.426q0-.775,0-1.55m.75,1.227h2.429v-2.435h-2.429Z",
    transform: "translate(-163.888 -209.878)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M97.631,219.637v-1.626c-.247-.051-.364-.152-.386-.328a.367.367,0,0,1,.1-.318c.13-.133.26-.266.395-.394a.366.366,0,0,1,.533,0c.12.114.233.235.352.349a.384.384,0,0,1,.131.423.37.37,0,0,1-.366.259v1.638a.388.388,0,0,1,.369.274.355.355,0,0,1-.09.366c-.131.137-.265.273-.4.4a.365.365,0,0,1-.524,0c-.129-.122-.251-.251-.378-.376a.37.37,0,0,1-.107-.4.352.352,0,0,1,.33-.257.246.246,0,0,0,.043-.013",
    transform: "translate(-94.022 -209.898)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M172.231,145.643h-1.623a1.317,1.317,0,0,1-.038.152.368.368,0,0,1-.6.138c-.143-.131-.28-.27-.412-.412a.363.363,0,0,1,0-.515c.107-.115.224-.22.331-.335a.413.413,0,0,1,.439-.158c.159.046.234.149.277.377h1.618c0-.006.008-.009.009-.013.118-.433.409-.509.728-.189.1.1.207.2.306.308a.371.371,0,0,1,0,.543c-.117.122-.24.24-.359.36a.372.372,0,0,1-.4.118.361.361,0,0,1-.26-.328.32.32,0,0,0-.014-.046",
    transform: "translate(-163.846 -139.927)",
    fill: "#0000b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_819",
    "data-name": "Rectangle 819",
    transform: "translate(427 678)",
    fill: "#fff",
    stroke: "#0000b5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 4,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_820",
    "data-name": "Rectangle 820",
    transform: "translate(427 686)",
    fill: "#fff",
    stroke: "#0000b5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 4,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_821",
    "data-name": "Rectangle 821",
    transform: "translate(427 694)",
    fill: "#fff",
    stroke: "#0000b5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 4,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 4,
    transform: "translate(422.5 680.5)",
    fill: "none",
    stroke: "#0000b5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 7,
    transform: "translate(419.5 688.5)",
    fill: "none",
    stroke: "#0000b5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 4,
    transform: "translate(422.5 696.5)",
    fill: "none",
    stroke: "#0000b5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y2: 16.5,
    transform: "translate(423 680)",
    fill: "none",
    stroke: "#0000b5",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectSubtype);
export default __webpack_public_path__ + "static/media/project-subtype.9ef936c60643076874c5fb48954452cf.svg";
export { ForwardRef as ReactComponent };